<template>
    <div>
      <common-dialog
        ref="dialog"
        width="700px"
        :show-save-button="$permission.canEdit()"
        unit="商家等级"
        edit-title
        id-key="RecordId"
        :data="data"
        form-label-width="125px"
        :form-rules="rules"
        :save-func="api.save"
        @create-opened="onCreateOpened"
        @edit-opened="onEditOpened"
        close-on-saved
        :before-save="onBeforeSave"
        @closed="onClosed"
        @close-saved="$emit('close-saved')"
      >
        <template slot="form">
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="等级名称" prop="GradeName">
                <el-input v-model="data.GradeName" placeholder="请填写等级名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="价格折扣" prop="Discount">
                <el-input v-model="data.Discount" type="number" placeholder="请填写价格折扣" clearable><template slot="append">折</template></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
                <el-form-item label="升级条件" prop="UpCondition">
                <el-input v-model="data.UpCondition" type="number" placeholder="请填写升级条件" clearable>><template slot="append">元</template></el-input>
                <div style="font-family:微软雅黑;font-size:12px;color:rgb(191, 187, 187);margin-top:-5px;text-indent: 15px;">消费累计金额达到数值后自动升级</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="isMB?24:12" style="margin-top:-20px">
              <el-form-item label="序号" prop="OrderId">
                <el-input-number v-model="data.OrderId" :min="0" />
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12" style="margin-top:-25px">
              <el-form-item label="状态" prop="State">
                <el-radio-group v-model="data.State">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
         
        </template>
        <template #footer v-if="!$permission.canEdit()">
           <el-button @click="close">关 闭</el-button>
      </template>
      </common-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
 
  
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
    
    },
    data() {
      return {
        data: {
          RecordId: 0,
          GradeName: "",
          Discount: "",
          UpCondition: "",
          Notes: "",
          OrderId: 0,
          State: 1,
        },
        api: require("@/api/shop/grade").default,
        isMB: this.$store.state.isMB,
        rules: {
          GradeName: [{ required: true, message: "等级名称不能为空" }],
          Discount: [{ required: true, message: "价格折扣不能为空" }],
          OrderId: [{ required: true, message: "序号不能为空" }],
        },
      };
    },
    methods: {
      onCreateOpened(row) {
        this.api.getMaxOrderId().then(res => {
          if(res.Code==0) this.data.OrderId = res.Data;
        })
      },
      onEditOpened(row) {
        
      },
      onBeforeSave() {
        if (this.data.UpCondition==0) {  //UpCondition就是具体字段名称
          this.$message.error("升级条件不能为0");
          return false;
        }
      },
      onClosed() {
  
      },
    },
  };
  </script>